import { useParams } from "react-router-dom";
import { Tooltip } from "antd";
import { showGlobalModal } from "components/GlobalModal";
import { useEffect, useRef, useState } from "react";
import { useGlobalState } from "state";

const ResetAndSubmit = ({ resetForm, submitLabel, isError, submitToolTip, skipButtonAndFunction, skipLabel ,setIsSection1Complete}: { skipButtonAndFunction?: () => void; resetForm?: any, submitLabel?: string, isError?: boolean, submitToolTip?: string, skipLabel?: string ,setIsSection1Complete?: (value: boolean) => void }) => {

    let instituteData = null;
    const params = useParams();

    try {
        instituteData = JSON.parse(sessionStorage?.getItem('_DATA_') || '{}');
    } catch (err) { }

    const handleResetAndSubmit = () => {
        // return ((params?.["*"] === "instituteInfo" || params?.["*"]?.split("/")?.[0] === "instituteInfo") && !!instituteData?.BRANCH_ID) ? false : true;
        return true;
    }

    return handleResetAndSubmit() ? <div className="flex justify-between gap-[1.5vw] mt-[1.6vw]">
        {!!skipButtonAndFunction && <button
            type="button"
            className="px-[2.4vw] py-[0.8vw] text-[0.83vw] font-medium text-gray-900 bg-white border border-gray-300 rounded-[0.25vw] focus:outline-none hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100"
            onClick={() => {
                showGlobalModal(`Do you want to skip ${params?.["*"] === "instituteInfo" ? "School Info".toUpperCase() : (params?.["*"]?.split("/")?.at(-1) || params?.["*"]).toUpperCase()}?`, "warning", {
                    showConfirm: true,
                    onConfirm: () => {
                        skipButtonAndFunction()
                    },
                    onCancel: () => {
                        console.log("User canceled deletion");
                    }
                });
            }}
        >
            {skipLabel || "Skip"}
        </button>}
        {!!resetForm && <button
            type="button"
            className="w-[13vw] py-[1.3vh] text-[1.125vw]  text-center  font-inter font-[400] text-[#000] bg-[#fff] border-[0.5px] border-[#3E3E3E]  rounded-[8px] focus:outline-none hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 mr-[0.4vw]"
            onClick={() => {
                showGlobalModal(`Do you want to reset ${params?.["*"] === "instituteInfo" ? "School Info".toUpperCase() : (params?.["*"]?.split("/")?.at(-1) || params?.["*"]).toUpperCase()}?`, "warning", {
                    showConfirm: true,
                    onConfirm: () => {
                        resetForm()
                    },
                    onCancel: () => {
                        console.log("User canceled deletion");
                    }
                });
            }}
        >
           ← Back
        </button>}
        <Tooltip title={submitToolTip} placement="left">
            <button
                type="submit"
                disabled={isError}
                className={`${isError ? "opacity-25 " : " "} inline-flex items-center justify-center w-[13vw] py-[1.3vh] text-[1.125vw] font-inter font-[400] text-center text-[#fff] bg-[#374AF2] rounded-[6px] hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 focus:outline-none`}
                style={{ color: 'white' }}
                
            >
                {submitLabel || "Next"}
                <svg 
                    className="w-[1vw] h-[1vw] ml-[0.5vw]" 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24" 
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path 
                        strokeLinecap="round" 
                        strokeLinejoin="round" 
                        strokeWidth={2} 
                        d="M14 5l7 7m0 0l-7 7m7-7H3" 
                    />
                </svg>
            </button>
        </Tooltip>
    </div> : <></>
}

export default ResetAndSubmit;